module.exports = __webpack_public_path__ + "img/ícone-mais.d482d291.svg";